<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addDiagnose" style="width: 96px">新增诊断</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="diagnoseName" label="诊断名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editDiagnose(scope.row)">编辑</el-button>
                            <el-button type="text" class="delete-button" @click="deleteDiagnose(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增诊断" :visible.sync="dialogAddVisible" width="520px">
            <el-form :model="diagnoseAdd" :rules="addRules" ref="addDiagnose" size="small">
                <el-form-item label="诊断名称" label-width="100px" prop="diagnoseName">
                    <el-input v-model="diagnoseAdd.diagnoseName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑诊断" :visible.sync="dialogEditVisible" width="520px">
            <el-form :model="diagnoseEdit" :rules="editRules" ref="editDiagnose" size="small">
                <el-form-item label="诊断名称" label-width="100px" prop="diagnoseName">
                    <el-input v-model="diagnoseEdit.diagnoseName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 表格信息
                tableData: [
                    {
                        diagnoseId: '1',
                        diagnoseName: '感冒',
                    }
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增诊断弹窗数据
                diagnoseAdd:{
                    diagnoseName: '',
                },
                addRules: {
                    diagnoseName: [{required: true, message: '请输入诊断名称', trigger: 'blur'},],
                },
                // 编辑诊断弹窗数据
                diagnoseEdit:{
                    diagnoseName: '',
                },
                editRules: {
                    diagnoseName: [{required: true, message: '请输入诊断名称', trigger: 'blur'},],
                },
            }
        },
        methods: {
            // 获取诊断列表
            queryDiagnose() {
                console.log("aaa")
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.queryDiagnose();
            },
            // 打开新增诊断弹窗
            addDiagnose() {
                this.dialogAddVisible =true
                this.$nextTick(()=>{
                    this.$refs.addDiagnose.resetFields();
                });
            },
            // 确定添加诊断
            confirmAdd() {
                console.log(this.diagnoseAdd.diagnoseName)
            },
            // 打开编辑诊断弹窗
            editDiagnose(data) {
                this.dialogEditVisible = true
                console.log(data)
                this.diagnoseEdit.diagnoseName = data.diagnoseName
                this.$nextTick(()=>{
                    this.$refs.editDiagnose.clearValidate();
                });
            },
            // 确认编辑诊断
            confirmEdit() {
                console.log(this.diagnoseEdit.diagnoseName)
            },
            // 删除诊断
            deleteDiagnose(date) {
                this.$confirm('您确认要删除此诊断?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message.success('删除成功');
                    // this.axios.post('1000/10016/100023', params,{
                    //     headers:{
                    //         token: this.authorization
                    //     }
                    // }).then(res =>{
                    //     if(res.data.code === 10000) {
                    //         this.$message.success(res.data.message);
                    //         // 查询现有角色
                    //         this.queryRole()
                    //     } else {
                    //         this.$message.error(res.data.message);
                    //     }
                    // }).catch(error => {
                    //     this.$message.error(error);
                    // });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        created() {
            this.queryDiagnose()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>